module.exports = __webpack_public_path__ + "static/img/icon_no_recent_search.bf798ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_no_recent_search.svg
// module id = PJPI
// module chunks = 10